import { render, staticRenderFns } from "./openAccountForm.vue?vue&type=template&id=8163b67c&scoped=true&"
import script from "./openAccountForm.vue?vue&type=script&lang=js&"
export * from "./openAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./openAccountForm.vue?vue&type=style&index=0&id=8163b67c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8163b67c",
  null
  
)

export default component.exports